<template>
    <div>
        <div class="flex justify-content-between column-gap-3 gap-3 flex-column sm:flex-row align-items-center">
            <div class="flex align-items-center gap-3 align-self-start">
                <div class="report_page__title_img">
                    <img :src="getImageUrl" @error="imageNotFound = true" @click="reloadImage" />
                </div>
                <h3>{{ domain }}</h3>
            </div>
            <div v-if="isExistsData" class="align-self-end sm:align-self-center">
                <TemplatesModeSelector
                    v-model:mode="viewMode"
                    :options="options"
                    @update:mode="onChangeViewMode"
                />
            </div>
        </div>
        <div v-if="isExistsData">
            <template v-if="viewMode === 'single'">
                <div class="report_page__single_content flex flex-column w-full mb-5">
                    <div class="report_page__settings flex justify-content-between gap-2">
                        <div class="field m-0">
                            <label class="text-color-secondary">{{ $t('lang.robots.file_change_label') }}</label>
                            <AdaptersDropdown
                                v-model="model.single.date"
                                :options="response.dates"
                                optionDisabled="disabled"
                                optionLabel="date"
                                :placeholder="$t('lang.robots.select_date')"
                                class="w-full report_page__dropdown"
                                @change="onChange('single')"
                                panelClass="p-dropdown-panel-sm"
                            >
                                <template #value="{value}">
                                    <span>{{ getFormattedDate(value.firstUpdate, value.lastUpdate) }}</span>
                                </template>
                                <template #option="{option}">
                                    <span><b>{{ getFormattedDate(option.firstUpdate, option.lastUpdate) }}</b>, статус: {{option.statusCode}}</span>
                                </template>
                            </AdaptersDropdown>
                        </div>
                        <div class="flex gap-2 align-self-end">
                            <Button
                                icon="pi pi-copy"
                                class="tools-button"
                                :title="$t('lang.main.copy_to_clipboard')"
                                @click="onClickCopy('single')"
                                severity="secondary"
                            />
                            <Button
                                icon="pi pi-download"
                                class="tools-button"
                                :title="$t('lang.main.download_file')"
                                @click="onClickDownload('single')"
                                severity="secondary"
                            />
                        </div>
                    </div>
                    <div class="report_page__info flex flex-wrap column-gap-5 row-gap-3 pb-3 my-3">
                        <span>{{ $t('lang.robots.file_size') }} <b>{{ getFormatFilesize(model.single.data.robotsSize) }}</b></span>
                        <span>{{ $t('lang.robots.file_rows') }} <b>{{ model.single.data.robotsLines }}</b></span>
                        <span>{{ $t('lang.robots.file_status') }} <b>{{ model.single.data.statusCode }}</b></span>
                    </div>
                    <AdaptersMessage v-if="model.single.data.error.length > 0" :message="model.single.data.error" class="mx-3" />
                    <AdaptersMessage v-else-if="isLimitedDraw(model.single.data.robotsSize)" :message="$t('lang.robots.file_size_to_large')" class="mx-3" />
                    <ul v-else class="report_page__file_content pb-3">
                        <li v-for="row in getSingleData">
                            <span>{{ row }}</span>
                        </li>
                    </ul>
                </div>
            </template>
            <template v-else>
                <div class="flex justify-content-between gap-1 row-gap-3 flex-column md:flex-row">
                    <div class="flex flex-column w-full">
                        <div class="report_page__settings flex justify-content-between gap-2">
                            <div class="field m-0">
                                <label class="text-color-secondary">{{ $t('lang.robots.file_change_label') }}</label>
                                <AdaptersDropdown
                                    v-model="model.left.date"
                                    :options="response.dates"
                                    optionDisabled="disabled"
                                    optionLabel="date"
                                    :placeholder="$t('lang.robots.select_date')"
                                    class="w-full report_page__dropdown"
                                    @change="onChange('left')"
                                    panelClass="p-dropdown-panel-sm"
                                >
                                    <template #value="{value}">
                                        <span>{{ getFormattedDate(value.firstUpdate, value.lastUpdate) }}</span>
                                    </template>
                                    <template #option="{option}">
                                        <span><b>{{ getFormattedDate(option.firstUpdate, option.lastUpdate) }}</b>, статус: {{option.statusCode}}</span>
                                    </template>
                                </AdaptersDropdown>
                            </div>
                            <div class="flex gap-2 align-self-end">
                                <Button
                                    icon="pi pi-copy"
                                    class="tools-button"
                                    :title="$t('lang.main.copy_to_clipboard')"
                                    @click="onClickCopy('left')"
                                    severity="secondary"
                                />
                                <Button
                                    icon="pi pi-download"
                                    class="tools-button"
                                    :title="$t('lang.main.download_file')"
                                    @click="onClickDownload('left')"
                                    severity="secondary"
                                />
                            </div>
                        </div>
                        <div class="report_page__info flex flex-wrap column-gap-5 row-gap-3 mt-3">
                            <span>{{ $t('lang.robots.file_size') }} <b>{{ getFormatFilesize(model.left.data.robotsSize) }}</b></span>
                            <span>{{ $t('lang.robots.file_rows') }} <b>{{ model.left.data.robotsLines }}</b></span>
                            <span>{{ $t('lang.robots.file_status') }} <b>{{ model.left.data.statusCode }}</b></span>
                        </div>
                        <AdaptersMessage v-if="model.left.data.error.length > 0" :message="model.left.data.error" class="mx-3" />
                        <AdaptersMessage v-else-if="isLimitedDraw(model.left.data.robotsSize)" :message="$t('lang.robots.file_size_to_large')" class="mx-3" />
                    </div>
                    <div class="flex flex-column w-full">
                        <div class="report_page__settings flex justify-content-between gap-2">
                            <div class="field m-0">
                                <label class="text-color-secondary">{{ $t('lang.robots.file_change_label') }}</label>
                                <AdaptersDropdown
                                    v-model="model.right.date"
                                    :options="response.dates"
                                    optionDisabled="disabled"
                                    optionLabel="date"
                                    :placeholder="$t('lang.robots.select_date')"
                                    class="w-full report_page__dropdown"
                                    @change="onChange('right')"
                                    panelClass="p-dropdown-panel-sm"
                                >
                                    <template #value="{value}">
                                        <span>{{ getFormattedDate(value.firstUpdate, value.lastUpdate) }}</span>
                                    </template>
                                    <template #option="{option}">
                                        <span><b>{{ getFormattedDate(option.firstUpdate, option.lastUpdate) }}</b>, статус: {{option.statusCode}}</span>
                                    </template>
                                </AdaptersDropdown>
                            </div>
                            <div class="flex gap-2 align-self-end">
                                <Button
                                    icon="pi pi-copy"
                                    class="tools-button"
                                    :title="$t('lang.main.copy_to_clipboard')"
                                    @click="onClickCopy('right')"
                                    severity="secondary"
                                />
                                <Button
                                    icon="pi pi-download"
                                    class="tools-button"
                                    :title="$t('lang.main.download_file')"
                                    @click="onClickDownload('right')"
                                    severity="secondary"
                                />
                            </div>
                        </div>
                        <div class="report_page__info flex flex-wrap column-gap-5 row-gap-3 mt-3">
                            <span>{{ $t('lang.robots.file_size') }} <b>{{ getFormatFilesize(model.right.data.robotsSize) }}</b></span>
                            <span>{{ $t('lang.robots.file_rows') }} <b>{{ model.right.data.robotsLines }}</b></span>
                            <span>{{ $t('lang.robots.file_status') }} <b>{{ model.right.data.statusCode }}</b></span>
                        </div>
                        <AdaptersMessage v-if="model.right.data.error.length > 0" :message="model.right.data.error" class="mx-3" />
                        <AdaptersMessage v-else-if="isLimitedDraw(model.right.data.robotsSize)" :message="$t('lang.robots.file_size_to_large')" class="mx-3" />
                    </div>
                </div>
                <div class="report_page__compare_container">
                    <CodeDiff
                        :old-string="getLeftContent"
                        :new-string="getRightContent"
                        :output-format="outputFormat"
                    >
                        <template #stat>
                            <div class="flex gap-2">
                                <Button
                                    icon="pi pi-arrow-right-arrow-left"
                                    class="tools-button"
                                    :title="$t('lang.main.download_file')"
                                    @click="outputFormat = 'side-by-side'"
                                    severity="secondary"
                                    :disabled="outputFormat === 'side-by-side'"
                                />
                                <Button
                                    icon="pi pi-sort-alt"
                                    class="tools-button"
                                    :title="$t('lang.main.download_file')"
                                    @click="outputFormat = 'line-by-line'"
                                    severity="secondary"
                                    :disabled="outputFormat === 'line-by-line'"
                                />
                            </div>
                        </template>
                    </CodeDiff>
                </div>
            </template>
        </div>
        <div v-else class="mb-3">
            <span>{{ $t('lang.robots.data_not_exists') }}</span>
        </div>
    </div>
</template>

<script>
import {Listeners} from "../../constants/listeners";
import ProjectApi from "../../api/ProjectApi";
import Alerts from "../../mixins/Alerts";
import { CodeDiff } from 'v-code-diff'
import Button from "primevue/button";
import RobotsApi from "../../api/RobotsApi";
import AdaptersDropdown from "../../component/adapters/Dropdown.vue";
import {FormatHelper} from "../../helpers/FormatHelper";
import Clipboard from "../../mixins/Clipboard";
import Download from "../../mixins/Download";
import Divider from 'primevue/divider';
import AdaptersMessage from "../../component/adapters/Message.vue";
import moment from "moment/moment";
import TemplatesModeSelector from "../../templates/ModeSelector.vue";

export default {
    name: "RobotsReportPage",
    mixins: [Alerts, Clipboard, Download],
    props: {
        domain: {
            type: String,
            required: true,
        },
        domainIconUrl: {
            type: String,
            required: true,
        },
        initData: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            imageNotFound: false,
            loading: true,
            viewMode: 'single',
            options: [
                {label: this.$t('lang.robots.view_single'), value: 'single'},
                {label: this.$t('lang.robots.view_compare'), value: 'compare'},
            ],
            viewModes: [
                {caption: 'Обычный', id: 'single'},
                {caption: 'Сравнение', id: 'compare'}
            ],
            outputFormat: 'side-by-side',
            response: {
                dates: [],
                data: [],
            },
            model: {
                single: {
                    date: '',
                    data: {},
                },
                left: {
                    date: '',
                    data: {},
                },
                right: {
                    date: '',
                    data: {},
                }
            }
        }
    },
    mounted() {
        this.initSelectedOptions();
        this.response = this.initData;
    },
    computed: {
        getSingleData() {
            return this.model.single.data.content.split("\n");
        },
        isExistsData() {
            return this.response.dates.length > 0;
        },
        isExistsCompareData() {
            return this.response.dates.length > 1;
        },
        getImageUrl() {
            return this.imageNotFound ? '/i/project-image-not-found.webp' : this.domainIconUrl;
        },
        getLeftContent() {
            return this.isLimitedDraw(this.model.left.data.robotsSize) ? '' : this.model.left.data.content;
        },
        getRightContent() {
            return this.isLimitedDraw(this.model.right.data.robotsSize) ? '' : this.model.right.data.content;
        },
    },
    methods: {
        isLimitedDraw(robotsSize) {
            return robotsSize > 10_000_000;
        },
        getFormattedDate(firstUpdate, lastUpdate) {
            return firstUpdate === lastUpdate
                ? moment(lastUpdate).format('DD.MM.YYYY')
                : moment(firstUpdate).format('DD.MM.YYYY') + ' — ' + moment(lastUpdate).format('DD.MM.YYYY');
        },
        onClickCopy(type) {
            this.copyToClipboard(this.model[type].data.content);
        },
        onClickDownload(type) {
            this.downloadDataUtf8(
                this.model[type].data.content,
                sprintf('%s_%s.txt', this.domain, this.model[type].date.lastUpdate)
            );
        },
        onChangeViewMode(mode) {
            if (mode === 'compare' && !this.isExistsCompareData) {
                this.alertInfo(this.$t('lang.robots.compare_data_not_exists'));
                this.viewMode = 'single';
                return;
            }

            this.viewMode = mode;
        },
        getFormatFilesize(size) {
            return FormatHelper.formatBytes(size);
        },
        reloadImage() {
            this.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW);

            ProjectApi
                .reloadImage({"domainName": this.domain})
                .then(() => window.location.reload())
                .catch(error => this.alertError(error.message))
                .finally(() => this.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE));
        },
        onChange(type) {
            this.loading = true;
            RobotsApi
                .getData({domain: this.domain, date: this.model[type].date.lastUpdate})
                .then(response => {
                    this.model[type].data = response;
                })
                .catch(error => this.alertError(error))
                .finally(() => this.loading = false);
        },
        initSelectedOptions() {
            this.model.single.date = this.initData.dates[0];
            this.model.single.data = this.initData.data[0];
            this.model.left.date = this.initData.dates[1];
            this.model.left.data = this.initData.data[1];
            this.model.right.date = this.initData.dates[0];
            this.model.right.data = this.initData.data[0];
        }
    },
    components: {
        AdaptersDropdown,
        CodeDiff,
        Button,
        Divider,
        AdaptersMessage,
        TemplatesModeSelector,
    }
}
</script>

<style scoped>
.report_page__title_img {
    position: relative;
    cursor: pointer;
    flex-shrink: 0;
}
.report_page__title_img:hover:after {
    content: "↻";
    position: absolute;
    top: 0;
    right: 0;
    color: #87B945;
    line-height: 1;
    background-color: #fff;
}
.report_page__title_img img {
    height: 2.625rem;
    width: 2.625rem;
}
.report_page__settings {
    background-color: #F0F4F7;
    padding: 16px 20px;
    border-radius: 8px;
}
.report_page__dropdown {
    min-width: 235px;
}
.report_page__info {
    color: var(--secondary-color);
}
.report_page__compare_container {
    overflow-x: auto;
}
.report_page__compare_container > div {
    min-width: 500px;
}
.report_page__single_content {
    border: 1px solid #F0F4F7;
    border-radius: 16px;
}
.report_page__single_content .report_page__info {
    margin: 0 20px;
    border-bottom: 1px solid #F0F4F7;
}
.report_page__file_content {
    counter-reset: taskCounter;
    list-style-type: none;
}
.report_page__file_content > li:before {
    counter-increment: taskCounter;
    content: counter(taskCounter);
    min-width: 36px;
    color: var(--secondary-color);
    display: inline-block;
    text-align: right;
    margin-right: 15px;
}
.report_page__file_content > li {
    line-height: 1.5;
    font-family: ui-monospace, SFMono-Regular, SF Mono, Menlo, Consolas, Liberation Mono, monospace;
    font-size: 12px;
    color: var(--color-fg-default);
    display: flex;
}
.report_page__file_content span {
    word-break: break-all;
}
</style>
